module.exports = __webpack_public_path__ + "0d4d85523b253c05b72c57065ff2a67c.fbx";